/*---------------------------------------------------------------------------------------------
 *  Copyright (c) 2023 Vienna Hypertext Inc. All rights reserved.
 *--------------------------------------------------------------------------------------------*/

import styled from "styled-components";

import { BLOCK_TOPBAR_HEIGHT } from "src/lib/constants";

/* ----------------- Block Content ------------------ */

/**
 * Base style that wraps every block type with a like TextBlockContent, ImageBlockContent, etc.
 */
export const BaseBlockContent = styled.div`
  max-height: calc(100% - ${BLOCK_TOPBAR_HEIGHT}px); // don't love this
  flex-grow: 1;
  &::-webkit-scrollbar {
    display: none;
  }
`;

interface BlockContentContainerProps {
  isScreenshotter: boolean;
  isSelected?: boolean;
  editable?: boolean;
  boxShadow?: boolean;
  shouldScrollToBlock?: boolean;
}

export const BlockContentContainer = styled.div<BlockContentContainerProps>`
  position: absolute;
  flex-grow: 0;
  flex-shrink: 0;
  background: ${({ theme }) => theme.background};
  outline: ${({ shouldScrollToBlock }) => (shouldScrollToBlock ? "auto" : "")};
  border-bottom: ${({ theme, isScreenshotter }) => `${isScreenshotter ? "5" : "1"}px solid ${theme.block.border}`};
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  box-shadow: ${({ boxShadow, theme }) => boxShadow && `10px 10px ${theme.subtleContrast}`};
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  border: ${({ theme }) => `1px solid ${theme.block.border}`};
`;

export const StyledLoadingMessage = styled.div`
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 5px;
  font-family: "Inter", sans-serif;
  font-size: 16px;
  color: ${({ theme }) => theme.text.default};
  user-select: none;
`;
